module.exports = __webpack_public_path__ + "static/media/features6.1d386239.jpg";